// test2525
(2525 && 0);
